import React from "react";
import { Link } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import { connect } from "react-redux";

class VersionUpdateBanner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showBanner: (props.normalAppUpdateShow === false) ? false : true
        };

        this.closeVersionBanner = this.closeVersionBanner.bind(this);
        this.updateVersionBanner = this.updateVersionBanner.bind(this);
    }

    closeVersionBanner() {
        this.props.hideNormalAppUpdate();
    }
    updateVersionBanner() {
        if (window) {
            //debugger;
            window.location.reload(true);
        }
    }

    render() {
        const { showBanner } = this.state;
        const { message } = this.props;

        return (
            <React.Fragment>
                {showBanner &&
                    <div className="version-update-banner container-fluid">
                        <div className="row version-update-container text-center">
                            <div className="col-12 version-update align-self-center">
                            <div className="banner-message"> {message}
                                    <br className="mobile-element" />
                                    <Link className="banner-buttons__update" to="#" onClick={this.updateVersionBanner}>Update</Link>
                                    <Link to="#" className="banner-buttons__skip" onClick={this.closeVersionBanner}>Not Now</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </React.Fragment>
        );
    }
}

const defaultProps = {
    message: 'A new version is available! Would you like to update to the newest version?'
};

const mapStateToProps = (state) => {
    return {
        normalAppUpdateShow: state.header.normalAppUpdateShow
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        hideNormalAppUpdate: () => dispatch({ type: types.HIDE_NORMAL_APP_UPDATE })
    };
};

VersionUpdateBanner.defaultProps = defaultProps;
export default connect(mapStateToProps, mapDispatchToProps)(VersionUpdateBanner);

